import img1 from "../../../../assets/img/home/home3/Container.svg";
import img2 from "../../../../assets/img/home/home3/Container2.svg";
import img3 from "../../../../assets/img/home/home3/Container3.svg";
import img4 from "../../../../assets/img/home/home3/Container4.svg";
import img5 from "../../../../assets/img/home/home3/Container5.svg";

import mobile1 from "../../../../assets/img/home/home3/mobile1.png";
import mobile2 from "../../../../assets/img/home/home3/mobile2.png";
import mobile3 from "../../../../assets/img/home/home3/mobile3.png";
import mobile4 from "../../../../assets/img/home/home3/mobile4.png";
import mobile5 from "../../../../assets/img/home/home3/mobile5.png";



const DesktopPhotos = [img1, img2, img3, img4, img5];

const DesktopMobile = [mobile1, mobile2, mobile3, mobile4, mobile5];


export {DesktopPhotos, DesktopMobile};